class StreamingErrorCodes {
  static SESSION_INVALID = 'SESSION_INVALID';
  static NOT_CONNECTED = 'NOT_CONNECTED';
  static CONNECTION_LOST = 'CONNECTION_LOST';
  static CONNECTION_DENIED = 'CONNECTION_DENIED';
  static SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE';
  static SOCKET_UNAVAILABLE = 'SOCKET_UNAVAILABLE';
  static TIMEOUT = 'TIMEOUT';
  static REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';
  static INVALID_ID = 'INVALID_ID';
  static INVALID_RIC = 'INVALID_RIC';
  static INVALID_TOKEN = 'INVALID_TOKEN';
  static INVALID_REQUEST = 'INVALID_REQUEST';
  static MISSING_PARAMETERS = 'MISSING_PARAMETERS';
  static UNKNOWN_STATUS = 'UNKNOWN_STATUS';
  static UNKNOWN_MESSAGE = 'UNKNOWN_MESSAGE';
  static NO_STREAMING_PERMISSION = 'NO_STREAMING_PERMISSION';
}

export default class StreamingError extends Error {
  public source: string;
  public status: StreamingErrorCodes;

  constructor(source: string, status: StreamingErrorCodes, message: string) {
    super(message);
    this.source = source;
    this.status = status;

    // Would be nice to use, but is not supported in IE & Safari
    // Error.captureStackTrace(this, StreamingError);
  }
}

export { StreamingErrorCodes };
